__turbopack_context__.v({
  "headerWrapper": "header-module-scss-module__Fhj-nG__headerWrapper",
  "inverted": "header-module-scss-module__Fhj-nG__inverted",
  "isHidden": "header-module-scss-module__Fhj-nG__isHidden",
  "menuWrapper": "header-module-scss-module__Fhj-nG__menuWrapper",
  "navList": "header-module-scss-module__Fhj-nG__navList",
  "navigation": "header-module-scss-module__Fhj-nG__navigation",
  "neutral": "header-module-scss-module__Fhj-nG__neutral",
  "open": "header-module-scss-module__Fhj-nG__open",
});
